import { useState } from 'react'

import { Wizard, WizardStep } from '@factorialco/deprecated-design-system'

import { useMemo } from 'modules/core/hooks/useMemo'

import { Item } from 'modules/processes/domain'

import { useFeaturesProvider } from '../Providers/features'
import { useFormProvider } from '../Providers/form'
import { useItemProvider } from '../Providers/item'
import { useValidationsProvider } from '../Providers/validations'
import { fillInformationStep } from './Steps/FillInformation'
import { previewStep } from './Steps/Preview'
import { taskSelectorStep } from './Steps/TaskSelector'
import { useMutateItem } from './mutation'
import { WizardData } from './types'

type Props = {
  onClose: () => void
  item?: Item
}

const TaskWizard = ({ onClose, item }: Props) => {
  const { currentTaskType, currentStep, form, multiselectOpened, dueDateOpen } = useFormProvider()
  const { itemType } = useItemProvider()
  const { fieldWithErrors } = useValidationsProvider()
  const { loading } = useFeaturesProvider()

  const { onSubmit } = useMutateItem({
    item,
    form,
    dueDateOpen,
    currentStep,
    onClose,
  })

  const steps: WizardStep<WizardData>[] = useMemo(() => {
    return [taskSelectorStep(), fillInformationStep(), previewStep()]
  }, [])

  const [title, setTitle] = useState<string>()

  return (
    <Wizard.Modal
      locked={loading || multiselectOpened}
      icon="tasks_management"
      title={title}
      steps={steps}
      initialData={{
        taskType: currentTaskType,
        fieldWithErrors,
        setTitle,
        currentStepIndex: 0,
      }}
      onSubmit={onSubmit}
      size="large"
      bottomSpacing={false}
      onClose={onClose}
      {...(item && { defaultStepIndex: 1 })}
    />
  )
}

export default TaskWizard
